import JobsDetails from "../components/JobsDetails";
import UserLayout from "../components/UserLayout";

const JobDetailsPage = () => {
    return (
        <UserLayout>
            <JobsDetails />
        </UserLayout>
    );
}

export default JobDetailsPage;